import React from "react";
import { emojiMap } from "./emojiMap";
import EmojiItem from "./EmojiItem";

export default function EmojiTable({ onSelect }) {
    const groups = {};
    Object.entries(emojiMap).forEach(([key, emoji]) => {
        if (!groups[emoji.category]) groups[emoji.category] = [];
        groups[emoji.category].push({ key, ...emoji });
    });

    return (
        <div style={{ maxHeight: 400, overflowY: "auto", padding: 8 }}>
            {Object.entries(groups).map(([category, emojis]) => (
                <div key={category}>
                    <div style={{ fontWeight: "bold", margin: "8px 0" }}>{category}</div>
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fill, 28px)",
                            gap: "6px",
                        }}
                    >
                        {emojis.map((emoji) => (
                            <EmojiItem
                                key={emoji.key}
                                emoji={emoji}
                                onSelect={() => onSelect?.(emoji.key)}
                            />
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}
